import { BaseReducer } from '@identic/api';
import { CaseState, CaseInitialState, CaseActions } from './case.state';

export function CaseReducer(state: CaseState = CaseInitialState, action: any): CaseState {
  return BaseReducer(state, action, CaseActions);
}
// console.log(`%cCaseReducer::ngOnInit`, 'background:yellow');
